import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, Palette, ExternalLink } from "lucide-react";
import TopNav from "@/components/TopNav";

const SPRITE_MAKER_URL = "https://sprite-maker-lab.emergent.host/";

export default function DesignInstructions() {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen flex flex-col bg-[var(--bg-base)]"
      data-testid="design-page"
    >
      <TopNav />

      <main className="flex-1 w-full mx-auto max-w-3xl px-4 sm:px-6 pt-10 pb-32 flex flex-col items-center justify-center">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="w-full text-center"
        >
          <span
            className="arcade-btn arcade-btn-ghost text-[10px] px-3 py-1.5"
            data-testid="design-badge"
          >
            Design Team
          </span>

          <h1
            className="mt-6 font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-tight"
            data-testid="design-title"
          >
            Time to design your{" "}
            <span className="relative inline-block">
              <span className="relative z-10">game!</span>
              <span
                aria-hidden
                className="absolute -bottom-1 left-0 right-0 h-2.5 bg-[var(--accent)]/70 -rotate-1 rounded-sm z-0"
              />
            </span>
          </h1>

          <p
            className="mt-4 text-base sm:text-lg text-[var(--text-main)]/80 max-w-xl mx-auto leading-relaxed"
            data-testid="design-subtitle"
          >
            Go to the Game:bit website to start making your game.
          </p>
        </motion.div>

        <motion.a
          href={SPRITE_MAKER_URL}
          target="_blank"
          rel="noopener noreferrer"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.4 }}
          data-testid="design-start-btn"
          className="arcade-btn mt-10 px-6 py-4 text-sm sm:text-base"
        >
          <Palette strokeWidth={3} className="h-5 w-5" />
          Start Designing
          <ExternalLink strokeWidth={3} className="h-4 w-4 opacity-70" />
        </motion.a>
      </main>

      {/* Back button */}
      <div
        className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 flex items-center gap-6"
        data-testid="design-bottom-nav"
      >
        <button
          type="button"
          onClick={() => navigate("/select-volunteer")}
          aria-label="Back to role selection"
          data-testid="design-prev-btn"
          className="arcade-btn arcade-btn-icon"
        >
          <ChevronLeft strokeWidth={3} className="h-6 w-6" />
        </button>
      </div>
    </div>
  );
}
